import Box from '@mui/material/Box';
import Header from './Header';

export default function AppLayout({ children }: { children: React.ReactNode }) {
	return (
		<div className='pb-12 min-h-screen w-full flex flex-col items-stretch'>
			<Header />
			<div className='w-full px-4 sm:px-6 md:px-8 max-w-[1300px] mx-auto flex-1 flex-shrink'>{children}</div>
		</div>
	);
}
